import styled from 'styled-components';
import { rem } from 'polished';
import { breakpoints } from '../../../../../styles/theme';
import { HeaderStyled } from '../../HeaderStyled';

export const HeaderStyledOVGB = styled(HeaderStyled)`
    .header {
        background: ${({ theme }) => theme.colors.pureWhite};

        .logoWrapper {
            color: ${({ theme }) => theme.colors.black};

            span {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                text-transform: uppercase;
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            h1 {
                display: none;
            }
        }

        .logo {
            svg {
                width: ${rem(50)};
                height: ${rem(50)};
            }

            @media (min-width: ${breakpoints.md}px) {
                svg {
                    width: ${rem(70)};
                    height: ${rem(70)};
                }
            }
        }

        .desktopCenterPart {
            @media (min-width: ${breakpoints.md}px) {
                position: absolute;
                left: 0;
            }
        }

        .desktopRightPart {
            .link-wrapper,
            .help,
            .account,
            .basket,
            .pro {
                font-size: ${({ theme }) => theme.fontSizes.h6};
                text-transform: uppercase;

                .label {
                    color: ${({ theme }) => theme.colors.black};
                    margin-top: ${rem(4)};

                    .phone {
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    }
                }

                svg {
                    width: ${rem(20)};
                    height: ${rem(20)};
                }
            }
        }

        .mobileMenu {
            background: ${({ theme }) => theme.colors.pureWhite};

            .navigation {
                .link-wrapper,
                .help,
                .account,
                .basket,
                .pro {
                    font-size: ${({ theme }) => theme.fontSizes.h5};

                    .label {
                        text-align: left;
                        color: ${({ theme }) => theme.colors.black};
                    }
                }
            }

            .close {
                color: ${({ theme }) => theme.colors.black};
            }
        }

        .mobileMenuIcon {
            svg {
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.black} !important;
                    }
                }
            }
        }
    }

    .b2b-switch input:checked + button {
        label {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .b2b-switch .toggle-inside {
        border-color: ${({ theme }) => theme.colors.black};
        background: ${({ theme }) => theme.colors.black};
    }

    .switch-vertical label {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        color: ${({ theme }) => theme.colors.black};
    }
`;
